import React from 'react';
import { wrapperStyle, labelStyle } from '../styles.js';
var StubbedWrapper = function StubbedWrapper(_ref) {
  var children = _ref.children;
  return React.createElement("section", {
    "data-testid": "stubbed-wrapper",
    style: wrapperStyle
  }, React.createElement("div", {
    style: labelStyle
  }, "Stubbed Payment"), children);
};
export { StubbedWrapper as default };